<template>
    <div>
        <div class="modal fade" id="fundproject" tabindex="-1" aria-labelledby="fundproject" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title title-modal" id="addCoach">Fund Project</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mt-4">
                        <div class="form-group selected-option" v-if="projectItem.payment_type == 'pay_at_will' && projectItem.equity_payment_date != null">
                            <label for="amount">Amount (₦)</label>
                            <input :disabled="projectItem.payment_type == 'outright_payment || payment_plan'" onfocus="(this.type='text')" type="number" v-model="transferAmount" class="form-control inputt" id="amount" placeholder="Enter Amount">
                        </div>
                        <div class="form-group selected-option" v-else>
                            <label for="amount">Amount (₦)</label>
                            <h6 style="text-align: left;">{{ Number(displayAmount).toLocaleString() }}</h6>
                        </div>
                        
                    </div>

                    <!-- <div class="container" v-if="projectItem.payment_type == 'pay_at_will' && projectItem.equity_payment_date != null">
                        <div class="amount-options">
                            <button class="btn" @click="transferAmount = 10000">₦10,000</button>
                            <button class="btn" @click="transferAmount = 20000">₦20,000</button>
                            <button class="btn" @click="transferAmount = 30000">₦30,000</button>
                        </div>
                        <div class="amount-options">
                            <button class="btn" @click="transferAmount = 40000">₦40,000</button>
                            <button class="btn" @click="transferAmount = 50000">₦50,000</button>
                            <button class="btn" @click="transferAmount = 60000">₦60,000</button>
                        </div>
                    </div> -->
        
                    <div class="form-group button-class container">
                        <button :disabled="payloader" class="btn primaryBtn w-100" @click="paymentActions()">
                            {{ payloader ? 'Please wait...' : 'Fund project now' }}
                            <i
                              class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                              v-if="payloader"
                              >
                          </i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
// import moment from "moment";
import $ from "jquery";
// import Vue from "vue";
export default {
    components: {
        PageLoader,
    },
    props: {
        // projectData: {
        //     type: Object,
        //     required: true
        // },
        projectItem: {
            type: Object,
            default: () => null,
            required: true
        }
    },

    data() {
        return {
            payloader: false,
            transferAmount: "",
            rawTransferAmount: "",
            displayAmount: "",
        };
    },
    watch: {
        transferAmount(newValue) {
            if (!newValue) {
                this.rawTransferAmount = 0;
                return;
            }
            const cleanNumberStr = newValue.replace(/\D/g, "");
            this.rawTransferAmount = Number(cleanNumberStr);
            const result = cleanNumberStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.$nextTick(() => {
                this.transferAmount = result;
            });
        },
        projectItem: {
            handler(newVal) {
                if (newVal) {
                this.viewProjectDetails();
                }
            },
            deep: true // Essential if you modify nested properties inside the object
        }
    },
    created() {

    },
    mounted() {
        if (this.projectItem) {
            this.viewProjectDetails();
        }
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        viewProjectDetails() {
        // Put your setup, API calls, or formatting logic here            
            if (this.projectItem.payment_type == 'payment_plan' && this.projectItem.equity_payment_date == null) {
                this.displayAmount = this.projectItem.actual_equity_contribution_value;
            } else if (this.projectItem.payment_type == 'pay_at_will' && this.projectItem.equity_payment_date == null) {
                this.displayAmount = this.projectItem.actual_equity_contribution_value;
            }
            else if (this.projectItem.payment_type == 'pay_at_will' && this.projectItem.equity_payment_date != null) {
                this.displayAmount = this.rawTransferAmount;
            }
            else if (this.projectItem.payment_type == 'outright_payment') {
                this.displayAmount = this.projectItem.unit_price;
            }

        },
        paymentActions() {
            // console.log("Project", this.projectItem)
          this.payloader = true;
          try {
            let theMainUrl = '';
            let mainPayload = {};
            const equityUrl = "pay_project_equity_contribution";
            const fundPayAtWill = "fund-corporate-joinned-project";
            const outrightPayment = "pay-outright-payment-corporate-joinned-project";

            const thePayload1 = {
                project_id: this.projectItem.id, 
                payment_method: 'safe', 
            }
            const thePayload2 = {
                project_id: this.projectItem.id, 
                payment_method: 'safe', 
                amount: this.projectItem.unit_price,
            }
            const thePayload3 = {
                project_id: this.projectItem.id, 
                payment_method: 'safe', 
                amount: this.rawTransferAmount
            }

            if (this.projectItem.payment_type == 'payment_plan' && this.projectItem.equity_payment_date == null) {
                theMainUrl = equityUrl;
                mainPayload = thePayload1;
            } else if (this.projectItem.payment_type == 'pay_at_will' && this.projectItem.equity_payment_date == null) {
                theMainUrl = equityUrl;
                mainPayload = thePayload1;
            }
            else if (this.projectItem.payment_type == 'pay_at_will' && this.projectItem.equity_payment_date != null) {
                theMainUrl = fundPayAtWill;
                mainPayload = thePayload3;
            }
            else if (this.projectItem.payment_type == 'outright_payment') {
                theMainUrl = outrightPayment;
                mainPayload = thePayload2;
            }
            else {
                return this.$store.commit("setApiFailed", "Payment will be deducted from safe");
            }


            Api.postRequest(theMainUrl, mainPayload).then(res => {
            //   console.log("Project respose", res)
              this.payloader = false;
              if(res.data.success) {
                $("#availableprojectdetails")
                .removeClass("fade")
                .modal("hide");
                window.location.reload();
                return this.$store.commit("setApiSuccess", "Success");
              }
              if (res.data.error) {
                return this.$store.commit("setApiFailed", res.data.error);
              }
            }).catch(err => {
              this.payloader = false;
              console.log("Error:", err)
            });
          } finally {

          }
        }
    }
};
</script>

<style lang="scss" scoped> 
.button-class {
    margin-bottom: 50px;
    .primaryBtn {
        background: #0033EA;
        color: #ffffff;
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        height: 45px;
        outline: 0;
        box-shadow: none;
    }
}

.selected-option {
    label {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        color: #1A1A1A;
        text-align: left;
        display: flex;

    }
    input, select, h6 {
        padding: 10px;
        border: 1px solid #E6E9EC;
        cursor: pointer;
        // display: flex;
        // align-items: center;
        // gap: 10px;
        background: #fff;
        border-radius: 4px;
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        box-shadow: none;
        outline: 0;
        height: 55px;
    }
    h6 {
        display: flex;
        align-items: center;
        text-align: left;
        overflow: scroll;
    }
}

.amount-options {
    button {
        background: #F8F9FA;
        color: #555555;
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        text-align: center;
        border-radius: 4px;
        height: 45px;
        margin: 10px 4px;
        outline: 0;
        box-shadow: none;
    }
    button:hover {
        background: #c8c9c9;
        border: 1px solid #c8c9c9;
    }
}

</style>